import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { take } from 'rxjs/operators';
import { DropDownListDTO } from '../entity/dto/dropdownlist.component';
import { NotificationService } from './notification.service';
import { ActionMessage, TypeMessage } from '../entity/enum/enum-notification';
import { ColumnsListDTO } from '../entity/dto/columnslist.component';

export abstract class BaseService<T> {

    constructor(protected http: HttpClient) {
    }

    getAll(sheet?: string, model?: T): Observable<T[]> {
        return this.http.post<T[]>(`${environment.api}v1/sheet/${sheet}/list`, model, { headers: this.getOptions() });
    }

    getAllFilter(sheet?: string, model?: T): Observable<any> {
        return this.http.post<any>(`${environment.api}v1/sheet/${sheet}/list`, model, { headers: this.getOptions() });
    }

    getById(sheet: string, id: number): Observable<T> {
        return this.http.post<T>(`${environment.api}v1/sheet/${sheet}/get/${id}`, {}, { headers: this.getOptions() });
    }

    create(sheet: string, model: T): Observable<T> {
        return this.http.post<T>(`${environment.api}v1/sheet/${sheet}/create`, model, { headers: this.getOptions() });
    }

    update(sheet: string, model: T): Observable<T> {
        return this.http.put<T>(`${environment.api}v1/sheet/${sheet}/update`, model, { headers: this.getOptions() });
    }

    delete(id?: number): Observable<any> {
        return this.http.delete<any>(`${environment.api}v1/${id}`, { headers: this.getOptions() });
    }

    updateStatus(id?: number): Observable<T> {
        return this.http.put<T>(`${environment.api}v1/${id}`, '', { headers: this.getOptions() });
    }

    exportExcel(sheet?: string, data?: string[], dataFilters?: string[]): Observable<any> {
        const objectJSON = { columns: data, filters: dataFilters };
        const columns = { columns: data };
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/sheet/${sheet}/download`, columns, { headers: this.getOptions(), responseType: 'blob' as 'json' });
    }

    getListDropDownList(sheet?: string, field?: string, site: string = 'all'): Observable<any> {
        return this.http.get<any>(`${environment.api}v1/sheet/${sheet}/field/${field}/site/${site}`, { headers: this.getOptions() });
    }
    getListDropDownListBySafra(sheet?: string, field?: string, safra?: string, site: string = 'all'): Observable<any> {
        return this.http.post<any>(`${environment.api}v1/sheet/${sheet}/field/${field}/site/${site}`, { safra }, { headers: this.getOptions() });
    }

    getList(sheet?: string, column?: string, site?: string): Observable<any> {
        return this.http.get<any>(`${environment.api}v1/sheet/${sheet}/column/${column}/site/${site}`, { headers: this.getOptions() });
    }

    getUser(): Observable<any> {
        const url = 'https://makeappback.velocity-np.ag/api/v1/user-info';
        return this.http.get<any>(`${url}`, { headers: this.getOptions() });
    }

    makeSync(sheet?: string, model?: T): Observable<T[]> {
        return this.http.post<T[]>(`${environment.api}v1/sheet/${sheet}/sync`, { data: model }, { headers: this.getOptions() });
    }

    getListGeneration = async () => {
        const fullUri = environment.api + 'v1/configuration/getGenerationDropDown/';
        return await this.http.get<DropDownListDTO[]>(fullUri, { headers: this.getOptions() }).toPromise();
    }

    getListHibridoDropdown = async () => {
        const fullUri = environment.api + 'v1/configuration/getHibridoRncLinhagemDropdown/';
        return await this.http.get<DropDownListDTO[]>(fullUri, { headers: this.getOptions() }).toPromise();
    }

    getListAnelDropdown = async (type: string) => {
        const fullUri = environment.api + 'v1/configuration/getAnelDropdown/' + type;
        return await this.http.get<DropDownListDTO[]>(fullUri, { headers: this.getOptions() }).toPromise();
    }

    getListDiscoDropdown = async (type: string) => {
        const fullUri = environment.api + 'v1/configuration/getDiscoDropdown/' + type;
        return await this.http.get<DropDownListDTO[]>(fullUri, { headers: this.getOptions() }).toPromise();
    }
    getListColumnSheet = async (sheet: string) => {
        const fullUri = environment.api + `v1/configuration/${sheet}/getTbColumnList/`;
        return await this.http.get<ColumnsListDTO[]>(fullUri, { headers: this.getOptions() }).toPromise();
    }



    getOptions(): HttpHeaders {
        const headers = new HttpHeaders()
            .set('content-type', 'application/json')
            .set('Access-Control-Allow-Origin', '*')
            .set('Authorization', `Bearer ${this.getCookie()}`);
        return headers;
    }

    getOptionsFile(): HttpHeaders {
        const headers = new HttpHeaders()
            .set('Access-Control-Allow-Origin', '*')
            .set('Authorization', `Bearer ${this.getCookie()}`);
        return headers;
    }

    hasErrorFormControl(formControl?: AbstractControl): string {
        return formControl.hasError('required') ? 'O campo é obrigatório' :
            formControl.hasError('minlength') ? 'O campo deve ser preenchido corretamente' :
                formControl.hasError('maxlength') ? 'O campo está com seu tamanho máximo ultrapassado' :
                    formControl.hasError('pattern') ? 'O campo está fora do padrão requisitado' :
                        formControl.hasError('invalidCerar') ? 'O cerar inserido já existe na base de dados. Preencha um novo cerar no campo' :
                            formControl.hasError('invalidCerar007') ? 'O cerar inserido não existe na base qua007. Preencha um cerar já cadastrado' :
                                formControl.hasError('invalidPeneira') ? 'Conferir peneira' :
                                    formControl.hasError('invalidRange') ? 'Conferir valores Min e Max' :
                                        formControl.hasError('invalidCheck') ? 'Verificar lançamentos, a soma das peneiras + topo + fundo + (peso sabugo / 10) está diferente de 100%' :
                                            formControl.hasError('invalidPesoPeneira') ? 'O peso não pode ser maior que o peso total da peneira' :
                                                formControl.hasError('invalidMediaPeso') ? 'Valor do peso médio não coerente com a peneira. Verificar lançamento ou pesagem/contagem.' :
                                                    formControl.hasError('invalidApolloSocidisco') ? 'Não é permitido números menores que 0 ou maiores que 30' :
                                                        formControl.hasError('invalidCerarSiteRecebimento') ? 'O Site Recebimento do Cerar informado não condiz com o Site de Recebimento do formulário ' :
                                                            formControl.hasError('invalidTerminoSecagem') ? 'Tempo total de secagem superior a 300h ' :
                                                                formControl.hasError('invalidUmidade') ? 'Os valores devem ser entre 5% e 40%.' :
                                                                    formControl.hasError('invalidSorter') ? 'Vazão Color Sorter incoerente, revisar valores' :
                                                                        formControl.hasError('duplicatedLoteSaida') ? 'Lote saída já existe, favor inserir outro.' :
                                                                            formControl.hasError('dateInitHighDateEnd') ? 'Data Início maior que data fim.' :
                                                                                formControl.hasError('invalidRessecagem') ? 'A data e hora de início da ressecagem não pode ser antes do término da secagem.' :
                                                                                    formControl.hasError('invalidSomaAmostra') ? 'A soma das impurezas tem que ser menor que o valor da amostra' :
                                                                                        formControl.hasError('invalidDebulha') ? 'A data e hora de término da debulha não pode ser antes do término da ressecagem.' :
                                                                                            formControl.hasError('invalidDebulhaTime') ? 'As horas de debulha não podem ser menor que as horas de ressecagem.' :
                                                                                                formControl.hasError('invalidCalc') ? 'O valor das impurezas tem que ser menor que o valor da amostra.' :
                                                                                                    formControl.hasError('invalidExist') ? 'O valor inserido já existe na base de dados. Preencha um novo valor no campo' :
                                                                                                        formControl.hasError('invalidPesoBruto') ? 'O Valor do peso bruto não pode ser maior que 65000' :
                                                                                                            formControl.hasError('invalidPesoTara') ? 'O Valor do peso tara não pode ser maior que 25000' :
                                                                                                                formControl.hasError('invalidPeso') ? 'O Valor do peso tara não pode ser maior que que o peso bruto' :
                                                                                                        '';
    }

    async getToken(): Promise<boolean> {
        const urlToGetToken = 'https://login.microsoftonline.com/fcb2b37b-5da0-466b-9b83-0014b67a7c78/oauth2/v2.0/token';
        return await this.http.post<any>(urlToGetToken,
            'grant_type=client_credentials&client_id=66a30c8a-a206-4707-a43c-762e37640523&client_secret=~56-Y2XXfja.kIBPbQGESA-8_54l4MYkG_&scope=66a30c8a-a206-4707-a43c-762e37640523/.default'
            , { headers: this.getOptionsHeader() }).pipe(take(1)).toPromise().then((response: string) => {
                this.setCookie('frontend-app', response, 30);
                return true;
            }).catch(error => {
                this.setCookie('frontend-app', 'blank cookie', 30);
                return false;
            });
    }

    getOptionsHeader(): HttpHeaders {
        const headers = new HttpHeaders()
            .set('content-type', 'application/x-www-form-urlencoded')
            .set('Access-Control-Allow-Origin', '*');
        return headers;
    }

    private getCookie(): string {
        const name = 'frontend-app=';
        const ca = document.cookie.split(';');
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length).trim();
            }
        }
        return '';
    }

    private setCookie(name?: string, value?: string, days?: number): void {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    deleteForm(sheet: string, id): Observable<any> {
        return this.http.delete<any>(`${environment.api}v1/sheet/${sheet}/delete/${id}`, { headers: this.getOptions() });
    }

    userIsAdmin(): Observable<boolean> {
        return this.http.get<boolean>(`${environment.api}v1/users/adm/isAdmin`, { headers: this.getOptions() });
    }

    userIsManager(): Observable<boolean> {
        return this.http.get<boolean>(`${environment.api}v1/users/adm/isManager`, { headers: this.getOptions() });
    }

    getDiscoList = async (type: string) => {
        const fullUri = environment.api + 'v1/configuration/getDiscoDropdown/' + type;
        return await this.http.get<DropDownListDTO[]>(fullUri, { headers: this.getOptions() }).toPromise();
    }

    getLotesTbFromQua042 = async (params: { lote_origem: string }) => {
        const url = environment.api + 'v1/qua042/lote_origem/info';
        return this.http.post<any>(url, { 'lote_origem': params.lote_origem }, { headers: this.getOptions() }).toPromise();
    }

    getLotesTb = async (lote_origem: string) => {
        const url = environment.api + 'v1/qua042/lote_origem';
        return this.http.post<any>(url, { 'lote_origem': lote_origem }, { headers: this.getOptions() }).toPromise();
    }

    saveCd003Recomendation = async (model: T) => {
        const url = environment.api + 'v1/cd003/save';
        return this.http.post<any>(url, model, { headers: this.getOptions() }).toPromise();
    }

    validateLotesSaidaQua042 = async (lote_saida: string) => {
        const url = environment.api + 'v1/qua042/lote_saida';
        return this.http.post<any>(url, { 'lote_saida': lote_saida }, { headers: this.getOptions() }).toPromise();
    }

}
